<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>Her Last Call to Louis MacNeice</span></p>
<p class="authorname"><span>Ken Bruen</span></p>
<p class="publisher"><img alt="logo" src="images/logo3.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?34d387e0